import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class HostelDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h1 style={{fontSize: '30px'}}>Hotel Management Courses in Chennai</h1>
				  
				  <p><i>“Hospitality is a skill that requires both physical and mental strength”</i>. MIET offers excellent skill-building and all operational aspects of hotel management. As the Best hotel management & <b>catering institute in Chennai,</b> MIET provides its students with the required knowledge and materials to boost their value and get them ready to be hired by top companies. 
                    </p><br/>
                    <h5 className="mb-0 mt-2">CRAFT COURSES:</h5><br/>
                    <p><i>“Spread Happiness through Taste”</i>. <br/>MIET offers the <b> best catering courses in Chennai</b> including, certain craftsmanship courses to its students with practical hands-on experience and excellent presentation skills that will let them be highly in demand by the best companies in the industry. With MIET’s excellent tutors, students get at-par knowledge as they would by working in the kitchen with Top Chefs.</p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">DEGREE & DIPLOMA COURSE:</h5><br/>
						<p><i>“Having one option is not an option”.</i><br/> MIET, the best <b> catering courses in Chennai,</b> offers you a choice of career in this sector. Students could either pursue their dream career professionally with a degree or they could opt for a diploma course that is specialized accordingly and is completed in a short duration. MIET, the <b> best hotel management in Chennai,</b> takes the liberty to provide opportunities to its students every step of the way, leading to better job preferences or qualifying for higher studies.
						</p><br/>
						<p>MIET is proud to be affiliated with The American Hotel & Lodging Educational Institute (AHLEI) an international institution that is known for its history for over 65 years in the field of hospitality. The course is enriched with international standards as only very few institutions in the world offer.</p><br/>
						<h4>Your Chance to Earn</h4><br/>
						<p>MIET, the best hotel management courses in Chennai, offers Internship programs to its students at High-end hotels for Practical experience and an additional monetary benefit.</p><br/>
						<p>Guaranteed Placements for students based on their Merit.</p><br/>
						<h4>PLACEMENT OPPORTUNITY</h4>
						<br/>
						<p>At MIET, the <b> best hotel management courses in Chennai,</b> we ensure placements of students with star hotels and restaurants where our students get an opportunity to stand out and shine in their work. We also provide excellent opportunities at Kitchens of India & Bombay Restaurant in Bremen, Germany - our sister ventures in the field of hotel management and catering.</p>
						<br/>
						<p>Are you looking for the<b> best hotel management course fees in Chennai?</b>  At MIET, we believe in providing world-class education at an affordable price. Our hotel management courses will equip you with the necessary skills and knowledge to excel in the industry. Enrol now and kickstart your career! Contact us today to learn more about our course fees and enrollment process.</p>
                    </ScrollAnimation>	

               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
						<h5 className="mb-0 mt-2">Admissions Begin every year (March-August) for courses Recognised by DET, Govt of TamilNadu</h5><br/>
                        <table>
							<tr>
								<th>S.No</th>
								<th>Course</th>
								<th>Duration</th>
								<th>Eligibility</th>
								<th>Affiliated to</th>
								<th>Category</th>
								<th>Admissions</th>
							</tr>
							<tr>
								<td>1</td>
								<td>B.Sc: Catering & Hotel Administration</td>
								<td>3 years</td>
								<td>12th Pass</td>
								<td>Tamil Nadu Open University (TNOU)</td>
								<td>Degree Course</td>
								<td>January (Calendar year) and May - July (Academic year)</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>2</td>
								<td>Diploma in HMCT</td>
								<td>3 years</td>
								<td>10th Pass</td>
								<td>American Hotel & Lodging Educational Institute (AHLEI)</td>
								<td>Diploma Courses</td>
								<td>January (Calendar year) and May - July (Academic year)</td>
							</tr>
							<tr>
								<td>3</td>
								<td>Diploma in Food Production</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Tamil Nadu open university (TNOU)</td>
								<td>Diploma Courses</td>
								<td>January (Calendar year) and May - July (Academic year)</td>
							</tr>
							<tr>
								<td>4</td>
								<td>Diploma in Food & Beverage</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Tamil Nadu open university (TNOU)</td>
								<td>Diploma Courses</td>
								<td>January (Calendar year) and May - July (Academic year)</td>
							</tr>
							<tr>
								<td>5</td>
								<td>Diploma in Bakery and Confectionary</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Tamil Nadu open university (TNOU)</td>
								<td>Diploma Courses</td>
								<td>January (Calendar year) and May - July (Academic year)</td>
							</tr>
							<tr>
								<td>6</td>
								<td>Front Office & Hotel Operational Management</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Department of Employment & Training, Govt. of Tamil Nadu</td>
								<td>Craft Courses</td>
								<td>March- August</td>
							</tr>
							<tr>
								<td>7</td>
								<td>House Keeping Management</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Department of Employment & Training, Govt. of Tamil Nadu</td>
								<td>Craft Courses</td>
								<td>March- August</td>
							</tr>
							<tr>
								<td>8</td>
								<td>Food & Beverage</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Department of Employment & Training, Govt. of Tamil Nadu</td>
								<td>Craft Courses</td>
								<td>March- August</td>
							</tr>
							<tr>
								<td>9</td>
								<td>Food Production</td>
								<td>1 year</td>
								<td>10th Pass</td>
								<td>Department of Employment & Training, Govt. of Tamil Nadu</td>
								<td>Craft Courses</td>
								<td>March- August</td>
							</tr>
							
						</table>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">Your Chance to Earn:</h5><br/>
                    <p>MIET offers Internship programs to its students at High-end hotels for Practical experience and an additional monetary benefit. </p>
                    <p><b>Guaranteed Placements for students based on their Merit.</b></p>

                    
					
                    </ScrollAnimation>	
					<ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <p><b>PLACEMENT OPPORTUNITY </b>:</p>
							<p>At MIET, we ensure placements of students with star hotels and restaurants where our students get an opportunity to stand out and shine in their work. We also provide excellent opportunities at Kitchens of India & Bombay Restaurant in Bremen, Germany - our sister ventures in the field of hotel management and catering.</p>
                    
                            </blockquote>
                        </div>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>

                  </div>
		      </div>
			  <Sidebar courseRestriction="Degree/Diploma/Craft"/>
		    </div>
		  </div>
		</div>

        }
}

export default HostelDetails